import { Box, Button } from "@mui/material";

const CreateAccountInlineEditor = () => {
  return (
    <Box>
      <Button variant="contained" size="small" sx={{ m: 1 }} disabled={true}>
        Create
      </Button>
    </Box>
  );
};

export default CreateAccountInlineEditor;
